import type { InternalAccessRole, InternalAccessUser } from 'src/interfaces/internalAccess'
import type { State } from '../reducers/types'

/**
 * Reference-returning only. Filtering, counting and option-building happen in components under
 * `useMemo` — a selector building a new array would re-render every consumer on each dispatch.
 */
export const getInternalUsers = (state: State): InternalAccessUser[] => {
  return state.internalAccess.users
}

export const getInternalUsersLoading = (state: State): boolean => {
  return state.internalAccess.usersLoading
}

export const getInternalUsersError = (state: State): string | null => {
  return state.internalAccess.usersError
}

export const getInternalRoles = (state: State): InternalAccessRole[] => {
  return state.internalAccess.roles
}

export const getInternalRolesLoading = (state: State): boolean => {
  return state.internalAccess.rolesLoading
}

export const getInternalRolesError = (state: State): string | null => {
  return state.internalAccess.rolesError
}

export const getInternalRoleDetail = (state: State): InternalAccessRole | null => {
  return state.internalAccess.roleDetail
}

export const getInternalRoleDetailLoading = (state: State): boolean => {
  return state.internalAccess.roleDetailLoading
}

export const getInternalRoleDetailError = (state: State): string | null => {
  return state.internalAccess.roleDetailError
}

export const getInternalUserSaving = (state: State): boolean => {
  return state.internalAccess.userSaving
}

export const getInternalRoleSaving = (state: State): boolean => {
  return state.internalAccess.roleSaving
}
